import axios from "axios";
import { toast } from "react-toastify";
import { Dispatch } from 'redux';

const API_URL = `${process.env.REACT_APP_API_URL}/settings`;

// Action Types
export const GET_SITE_SETTINGS_START = 'GET_SITE_SETTINGS_START';
export const GET_SITE_SETTINGS_SUCCESS = 'GET_SITE_SETTINGS_SUCCESS';
export const GET_SITE_SETTINGS_ERROR = 'GET_SITE_SETTINGS_ERROR';
export const UPDATE_SITE_SETTINGS_START = 'UPDATE_SITE_SETTINGS_START';
export const UPDATE_SITE_SETTINGS_SUCCESS = 'UPDATE_SITE_SETTINGS_SUCCESS';
export const UPDATE_SITE_SETTINGS_ERROR = 'UPDATE_SITE_SETTINGS_ERROR';
export const RESET_SITE_SETTINGS_STATE = 'RESET_SITE_SETTINGS_STATE';

// Action Creators
export const getSiteSettings = () => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: GET_SITE_SETTINGS_START });
        const {data} = await axios.get(`${API_URL}/getSettings`);
        dispatch({ type: GET_SITE_SETTINGS_SUCCESS, payload: data });
        return data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.msg || "Site ayarları alınırken bir hata oluştu";
        dispatch({ type: GET_SITE_SETTINGS_ERROR, payload: errorMessage });
        toast.error(errorMessage);
        throw error;
    }
}

export const updateSiteSettings = (formData: FormData) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: UPDATE_SITE_SETTINGS_START });
        const {data} = await axios.put(`${API_URL}/updateSettings`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({ type: UPDATE_SITE_SETTINGS_SUCCESS, payload: data });
        toast.success("Site ayarları başarıyla güncellendi");
        return data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.msg || "Site ayarları güncellenirken bir hata oluştu";
        dispatch({ type: UPDATE_SITE_SETTINGS_ERROR, payload: errorMessage });
        toast.error(errorMessage);
        throw error;
    }
}

export const resetSiteSettingsState = () => ({
    type: RESET_SITE_SETTINGS_STATE
});